import styled, { css } from 'styled-components'

import { theme } from 'styles/theme'

const { borderWidths, colors, fontSizes, fontWeights, media, radii, space } = theme

export const TokenFieldGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: ${space['spacing-xxs']};
  margin: ${space['spacing-lg']} 0 0;
`

export const TokenErrorMessage = styled.div`
  width: 100%;
  text-align: center;
  margin-top: ${space['spacing-xxs']};
`

const FILLED_TOKEN_STATE = {
  border: `${borderWidths['border-stroke-micro']} solid ${colors['blue-border-default']}`,
  background: 'none',
  color: colors['neutral-text-default'],
  borderRadius: radii['corner-radius-sm']
}

const ERROR_TOKEN_STATE = {
  border: `${borderWidths['border-stroke-micro']} solid ${colors['danger-background-default']}`,
  background: 'none',
  color: colors['danger-text-hover'],
  borderRadius: radii['corner-radius-sm']
}

export const TokenField = styled.input<{ tokenState: 'default' | 'filled' | 'error' }>`
  width: 100%;
  height: ${space['spacing-mega']};
  font-size: ${fontSizes['font-size-heading-4']};
  font-weight: ${fontWeights['font-weight-medium']};
  text-align: center;
  border: none;
  background: none;
  border-bottom: ${borderWidths['border-stroke-small']} solid ${colors['neutral-border-strong']};

  ${({ tokenState }) => tokenState === 'filled' && FILLED_TOKEN_STATE}
  ${({ tokenState }) => tokenState === 'error' && ERROR_TOKEN_STATE}

  &:focus {
    outline: none;

    ${({ tokenState }) =>
      tokenState === 'default' &&
      css`
        border-bottom: ${borderWidths['border-stroke-small']} solid ${colors['blue-border-strong']};
      `}
  }
`

export const ResendToken = styled.div`
  margin-top: ${space['spacing-xl']};
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${space['spacing-md']};

  p {
    strong: {
      margin-left: ${space['spacing-xxxs']};
      color: ${colors['blue-text-default']};
    }
  }

  a {
    outline: none;
    margin: 0 auto;
    height: auto;
    cursor: pointer;
  }
`

export const TokenNotReceivedMessage = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: center;
  margin-bottom: ${space['spacing-sm']};

  @media (${media.tablet}) {
    margin-top: ${space['spacing-xxl']};
  }
`
